import styled from 'styled-components';

export const TeamAssignmentDeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px; /* keep in sync with TeamAssignmentRow's divider padding-bottom below */
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 30px 48px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  width: 380px;
  max-height: 400px;
  overflow-y: auto;
`;

export const TeamAssignmentDeadlineTitle = styled.h3`
  margin: 0 0 8px;
  color: var(--black-dark, #1a2535);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
`;

export const TeamAssignmentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;

  &:not(:last-child) {
    padding-bottom: 12px; /* keep in sync with the container's gap above */
    border-bottom: 1px solid var(--grey-lighter, #f2f2f7);
  }
`;

export const TeamAssignmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  min-width: 0;
`;

export const TeamAssignmentName = styled.span`
  color: var(--black-dark, #1a2535);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

export const TeamAssignmentPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
`;

export const TeamAssignmentPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 8px;
  border-radius: 30px;
  background: #ffffff;
  border: 1px solid var(--grey-lighter, #f2f2f7);
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  white-space: nowrap;
`;

export const TeamAssignmentPillHighlight = styled.span`
  color: var(--black-dark, #1a2535);
  font-weight: 700;
`;

export const TeamAssignmentRowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
